import { defineMessage } from 'react-intl';

export const courseCommonI18n = {
  offlineClass: defineMessage({
    id: 'common:course.offline',
    defaultMessage: 'In-person class'
  }),
  onlineClass: defineMessage({
    id: 'common:course.online',
    defaultMessage: 'Online class'
  }),

  /* Course difficulty */
  difficultyBeginner: defineMessage({
    id: 'common:course.difficulty.beginner',
    defaultMessage: 'Beginner'
  }),
  difficultyIntermediate: defineMessage({
    id: 'common:course.difficulty.intermediate',
    defaultMessage: 'Intermediate'
  }),
  difficultyAdvanced: defineMessage({
    id: 'common:course.difficulty.advanced',
    defaultMessage: 'Advanced'
  }),
  beginnerClass: defineMessage({
    id: 'common:course.beginner-class',
    defaultMessage: 'Beginner class'
  }),
  intermediateClass: defineMessage({
    id: 'common:course.intermediate-class',
    defaultMessage: 'Intermediate class'
  }),
  advancedClass: defineMessage({
    id: 'common:course.advanced-class',
    defaultMessage: 'Advanced class'
  }),

  /* Target gender */
  malesOnly: defineMessage({
    id: 'common:course.males-only',
    defaultMessage: 'Males only'
  }),
  femalesOnly: defineMessage({
    id: 'common:course.females-only',
    defaultMessage: 'Females only'
  })
};
